export const GET_CUSTOMER_LIST = "GET_CUSTOMER_LIST";

export const UPDATE_CUSTOMER_NOTE = "UPDATE_CUSTOMER_NOTE";

export const GET_CUSTOMER_HISTORY = "GET_CUSTOMER_HISTORY";